enum OrderStatus {
  Open = 1,
  Canceled,
  Matched,
  SelfMatched,
  Expired,
}

export default OrderStatus;